<!-- =========================================================================================
    File Name: DragAndDropMultipleLists.vue
    Description: Drag and Drop to multiple lists
    ----------------------------------------------------------------------------------------
    Item Name: ESM - EASY SCHOOL MANAGEMENT
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card :title="$t('Assign_Remove_student')">
            
        <div class="vx-row mb-5">
          <div class="vx-col w-full md:w-1/2">
            <vs-button :disabled="!salle" icon-pack="feather" color="success" icon="icon-check-circle" @click="saveAssign">{{ $t('Submit') }}</vs-button>
          </div>
          <div class="vx-col w-full md:w-1/2">
            <p class="mb-2" >{{ $t("room") }} </p>
            <v-select :options="salles" @search="getSalle" :clearable="true" label="libelle" v-model="salle" class="w-full"/>
          </div>
        </div>

        <!-- List 1 -->
        <div class="vx-row">
            <div class="vx-col w-full md:w-1/2">
                <vs-list>
                    <vs-list-item :title="$t('Select_all')">
                      <vs-checkbox slot="avatar" color="success" v-model="list1CheckBox"></vs-checkbox>

                      <vx-tooltip :text="$t('Remove_students_from_a_room')" color="danger">
                        <feather-icon
                          style="color: red"
                          icon="ArrowRightCircleIcon"
                          svgClasses="w-9 h-6 hover:text-danger stroke-current"
                          class="mr-2 cursor-pointer"
                          @click="remooveStudentFromRoom()"
                        />
                      </vx-tooltip>
                    </vs-list-item>

                    <vs-list-header :title="(main_salle ? main_salle.libelle : $t('room'))" color="primary"></vs-list-header>
                    <draggable :list="list1" group="people" class="p-2 cursor-move">
                      <vs-list-item v-for="(listItem, index) in list1" :key="index" :title="listItem.eleve.nom" :subtitle="listItem.eleve.prenoms">
                        <vs-checkbox slot="avatar" color="success" v-model="listItem.checkBox"></vs-checkbox>
                      </vs-list-item>
                    </draggable>
                </vs-list>
            </div>
            <div class="vx-col w-full md:w-1/2">
                <vs-list>
                    <vs-list-item :title="$t('Select_all')">
                      <vs-checkbox slot="avatar" color="success" v-model="list2CheckBox"></vs-checkbox>

                      <vx-tooltip :text="$t('Assign_a_room_to_students')" color="success">
                        <feather-icon
                          style="color: #28C76F"
                          icon="ArrowLeftCircleIcon"
                          svgClasses="w-9 h-6 hover:text-success stroke-current"
                          class="mr-2 cursor-pointer"
                          @click="assignRoomToStudent()"
                        />
                      </vx-tooltip>
                    </vs-list-item>

                    <vs-list-header :title="(salle ? salle.libelle : $t('room'))" color="primary"></vs-list-header>
                    <draggable :list="list2" group="people" class="p-2 cursor-move">
                      <vs-list-item v-for="(listItem, index) in list2" :key="index" :title="listItem.eleve.nom" :subtitle="listItem.eleve.prenoms">
                        <vs-checkbox slot="avatar" color="success" v-model="listItem.checkBox"></vs-checkbox>
                      </vs-list-item>
                    </draggable>
                </vs-list>
            </div>

        </div>
    </vx-card>
</template>

<script>
let base_self = ''
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      paramSalle: {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          q_list: []
        },
        orderby: ['ordre'],
        exclude: { id: this.$route.params.id }
      },
      paramInscription: {
        is_get: true,
        paginate: {
          length: 200,
          page: 1
        },
        filter: {
          q_list: [],
          abandon: false
        }
      },
      salles: [],
      salle: '',
      main_salle: '',
      list1CheckBox: false,
      list2CheckBox: false,
      list1: [],
      list2: []
    }
  },
  watch: {
    /* list1: {
      handler  () {
        this.mainCheckBoxInitialisation('list1')
      },
      deep: true
    },
    list2: {
      handler  () {
        this.mainCheckBoxInitialisation('list2')
      },
      deep: true
    }, */
    salle (value) {
      if (value) {
        this.getInscriptionSecond()
      } else {
        this.list2 = []
        this.getInscriptionSimple()
      }
    },
    list1CheckBox (value) {
      this.checkBoxInitialisation('list1', value)
    },
    list2CheckBox (value) {
      this.checkBoxInitialisation('list2', value)
    }
  },
  methods: {
    /* mainCheckBoxInitialisation (label) {
      const length = this[label].length
      for (let i = 0; i < length; i++) {
        if (!this[label][i].checkBox) {
          this[`${label}CheckBox`] = false
          console.log('Je suis de dant')
          break
        }
      }
    }, */
    async saveAssign () {
      base_self.$vs.loading()
      const inscriptions = []

      let length = base_self.list1.length
      for (let i = 0; i < length; i++) {
        const item = {
          id: base_self.list1[i].id,
          salle: base_self.main_salle.id
        }

        inscriptions.push(item)
      }

      length = base_self.list2.length
      for (let i = 0; i < length; i++) {
        const item = {
          id: base_self.list2[i].id,
          salle: base_self.salle.id
        }

        inscriptions.push(item)
      }

      const data = {
        many: true,
        data: inscriptions
      }
      
      base_self.$http.put(`${base_self.$store.state.route_for_esm}Inscription`, data)
        .then((response) => { 
          window.getESM.mettreAJourUneSalle(base_self.main_salle.id)
            .then(() => {
              window.getESM.mettreAJourUneSalle(base_self.salle.id)
                .then(() => {
                  window.getESM.success(base_self.$t('Changes_have_been_made_successfully'), response)
                  base_self.$vs.loading.close()
                  base_self.$router.push('/class_management/room').catch(() => {})
                })
                .catch(() => {
                  window.getESM.error(base_self.$t('The_server_is_not_responding'))
                })
            })
            .catch(() => {
              window.getESM.error(base_self.$t('The_server_is_not_responding'))
            })
        })
        .catch((error) => { 
          console.log('error: ', error)
          base_self.$vs.loading.close()
        })
    },
    getInscriptionSecond () {
      base_self.paramInscription.filter['salle'] = base_self.salle.id

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          if (!response.data.data.length) {
            window.getESM.error(base_self.$t('This_room_does_not_contain_students'))
          }

          base_self.list2 = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getInscriptionSimple () {
      base_self.paramInscription.filter['salle'] = base_self.$route.params.id

      base_self.$http.post(`${base_self.$store.state.route_for_esm}Inscription`, base_self.paramInscription)
        .then((response) => {
          if (response.data.data.length) {
            base_self.main_salle = response.data.data[0].salle
            base_self.list1 = JSON.parse(JSON.stringify(response.data.data))

            base_self.getSalleSimple()
          } else {
            window.getESM.error(base_self.$t('This_room_does_not_contain_students'))
          }
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      base_self.paramSalle.filter['classe'] = base_self.main_salle.classe.id
      base_self.paramSalle.filter['classe'] = base_self.main_salle.classe.id
      
      delete base_self.paramSalle.filter['libelle__icontains']
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      base_self.paramSalle.filter['libelle__icontains'] = search
      base_self.$http.post(`${base_self.$store.state.route_for_esm}Salle`, base_self.paramSalle)
        .then((response) => {
          base_self.salles = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    checkBoxInitialisation (label, value) {
      const length = this[label].length
      for (let i = 0; i < length; i++) {
        this[label][i].checkBox = value
      }
    },
    assignRoomToStudent () {
      const array = []
      for (let i = 0; i < this.list2.length; i++) {
        if (this.list2[i].checkBox) {
          this.list2[i].checkBox = false

          array.push(this.list2[i])
          this.list2.splice(i, 1)
          i--
        }
      }

      this.list2CheckBox = false
      this.list1.push(...array)
    },
    remooveStudentFromRoom () {
      const array = []
      for (let i = 0; i < this.list1.length; i++) {
        if (this.list1[i].checkBox) {
          this.list1[i].checkBox = false

          array.push(this.list1[i])
          this.list1.splice(i, 1)
          i--
        }
      }

      this.list1CheckBox = false
      this.list2.push(...array)
    }
  },
  components: {
    draggable
  },
  created () {
    base_self = this

    base_self.getInscriptionSimple()
  }
}
</script>
